<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 知识库管理 > 视频管理
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-input class="longInput" v-model="searchData.name" placeholder="输入关键字查询"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
								<el-button size="large" class="addBtn" @click="add">上传视频</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>

							<el-table-column align="center" label="视频名称" prop="title">
							</el-table-column>
							<el-table-column align="center" label="时长" prop="length">
								<template #default="{row}">
									<span>
										{{ formatDurings(row.length) }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="center" label="添加时间" prop="createTime">
							</el-table-column>
							<el-table-column align="center" label="重新发布" prop="status">
								<template #default="{row}">
									<span class="type publishing"
										v-if="row.status == 'publishing'">转码中,请勿操作</span>
									<span class="type published" v-if="row.status == 'published'">转码完成</span>
									<span class="type unpublished"
										v-if="row.status == 'unpublished'">转码未通过,请重新转码</span>
								</template>
							</el-table-column>
							<el-table-column align="center" label="操作" width="200">
								<template #default="{row}">
									<span class="editor" @click="editVideo(row)">
										编辑
									</span>
									<span style="margin-left: 10px;" class="editor" @click="sureDeployVideo(row)">
										重新转码
									</span>
									<span class="del" @click="delVideo(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total" :page-size="10"></el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增视频' : '编辑视频'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item label="上传视频" prop="path">
									<el-upload class="upload-demo" drag action="" :auto-upload="false"
										:on-change="handleChange" :file-list="fileList">
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">
											将文件拖到此处，或<em>点击上传</em>
											<br />
											<span
												style="font-size: 12px;color: #ccc;">支持AVI/mov/rmvb/vwv/rm/FLV/mp4/3GP/wmv格式上传</span>
										</div>
									</el-upload>
									<div v-if="fileObj" class="file-progress" style="margin-top: 30px;">
										<el-progress style="width: 400px;" :percentage="Number(percent.toFixed())">
										</el-progress>
									</div>
								</el-form-item>
								<el-form-item label="名称" prop="name">
									<el-input class="longInput" v-model="addUserForm.name"></el-input>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
		<video style="width: 1920px;height: 1080px;display: none;" id="video" controls>
			Your browser can't support HTML5 Audio
		</video>
	</div>
</template>
<script>
	import SparkMD5 from "spark-md5";
	export default {
		data() {
			return {
				total: 0,
				currentPage: 1,
				pages: 1,
				role: "",
				tabList: [{
						id: 0,
						name: "饮食推荐",
					},
					{
						id: 1,
						name: "体质管理",
					},
					{
						id: 2,
						name: "选项维护",
					},
					{
						id: 3,
						name: "健康评估",
					},
					{
						id: 4,
						name: "穴位维护",
					},
					{
						id: 5,
						name: "运动健康",
					},
					{
						id: 6,
						name: "药食管理",
					},
					{
						id: 7,
						name: "图片管理",
					},
					{
						id: 8,
						name: "视频管理",
					},
				],
				currentTabIndex: 8,
				searchData: {
					name: "", //脉诊结果
					type: "茶饮",
				},

				videoList: [],
				videoInfo: {}, //视频信息
				currentVideoIndex: 0,
				videoNum: -1,
				videoUploadFlag: false, //上传视频
				percent: 0,
				videoUrl: "",
				upload: true,
				percentCount: 0,
				chunkList: [],
				videoId: "",
				md5: "",
				fileObj: null,
				fileNum: -1,
				globalImageUrl: "",
				imageUrl: "",
				fileList: [],
				fileData: null,
				tableListData: [],
				pulseList: [],
				editVideoId: "", //编辑视频id
				imgArr: [],
				imgIndex: 0,
				baseImg: "",
				totalCutLen: 0, //切片总数
				quillContent: "",
				addUserForm: {
					name: "",
				},
				rules: {
					name: [{
						required: true,
						message: "请输入名称",
						trigger: "blur",
					}, ],
				},
				addOrEdit: "",
				addUserFlag: false,
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/knowledgeManagement/dietRecommend",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/knowledgeManagement/constituteManagement",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/knowledgeManagement/optionManagement",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/knowledgeManagement/healthAssessment",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/knowledgeManagement/physiothMainten",
					});
				}
				if (index == 5) {
					this.$router.push({
						path: "/knowledgeManagement/sportsHealth",
					});
				}
				if (index == 6) {
					this.$router.push({
						path: "/knowledgeManagement/drugManagement",
					});
				}
				if (index == 7) {
					this.$router.push({
						path: "/knowledgeManagement/picManagement",
					});
				}
				if (index == 8) {
					this.$router.push({
						path: "/knowledgeManagement/videoManagement",
					});
				}
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.addUserForm.name = "";
				this.addUserForm.id = "";
				this.editVideoId = "";
				this.percent = 0;
				this.addOrEdit = "add";
				this.fileObj = null;
				this.fileList = [];
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},

			//删除脉象
			delVideo(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						//this.delVideoId = item.id;
						this.sureDelVideo(item.id);
					})
					.catch(() => {});
			},
			//编辑视频
			editVideo(item) {
				this.addUserForm.name = item.name;
				this.addUserForm.id = item.id;
				this.editVideoId = item.id;
				this.addUserFlag = true;
				this.addOrEdit = "edit";
				this.percent = 0;
				this.getVideoDetail(item.id);
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//确认删除视频
			sureDelVideo(id) {
				this.$applicationJson("/business/shutcm/video/delete", {
						id: id, //视频id
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.$message.success("删除成功");
							this.delVideoFlag = false;
							this.getVideoList(this.currentPage);
							this.videoStatusStatistics();
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},

			//重新转码
			sureDeployVideo(item) {
				//console.log(item)
				this.$applicationJson("/business/shutcm/video/batch/deploy", {
						filename: item.filename, //文件名
						id: item.id, //id
						md5: "", //文件文件摘要
						sourcePath: "", //上传时文件路径
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.getVideoList(this.currentPage);
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},

			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			
			reset(){
				this.searchData.name = '';
				this.getVideoList(this.currentPage);
			},

			searchPluse() {
				this.getVideoList(this.currentPage);
				this.currentPage = 0;
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getVideoList(this.currentPage);
			},
			md5BigFile(file) {
				return new Promise((resolve, reject) => {
					let chunkSize = 2097152 * 8;
					let blobSlice =
						File.prototype.slice ||
						File.prototype.mozSlice ||
						File.prototype.webkitSlice;
					let chunks = Math.ceil(file.size / chunkSize);
					let currentChunk = 0;
					let spark = new SparkMD5.ArrayBuffer();
					let fileReader = new FileReader();

					fileReader.onload = function(e) {
						spark.append(e.target.result);
						currentChunk++;
						if (currentChunk < chunks) {
							loadNext();
						} else {
							let md5 = spark.end();
							resolve(md5);
						}
					};

					fileReader.onerror = function(e) {
						reject(e);
					};

					function loadNext() {
						let start = currentChunk * chunkSize;
						let end = start + chunkSize;
						if (end > file.size) {
							end = file.size;
						}
						fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
					}
					loadNext();
				});
			},
			//上传视频
			async handleChange(file) {
				if (!file) return;
				this.percent = 1;
				this.videoUrl = "";
				this.fileObj = file.raw;
				this.videoInfo = file.raw;
				this.videoList.push(file.raw); //暂时没用
				this.fileList = [];
				// FormData 对象
				this.fileList.push({
					name: this.fileObj.name,
					url: this.fileObj.path,
				});
				this.videoNum++; //暂时没用
				this.videoUploadFlag = true;
				this.addUserForm.name = file.raw.name.split(".")[0];
				let url = URL.createObjectURL(file.raw);
				document.getElementById("video").src = url;
				//截取5张图片供选择
				//[1, 20, 30, 40, 50].forEach(item => this.getVideoBase64(url, item));
				try {
					this.md5 = await this.md5BigFile(file.raw);
					let data = await this.checkBackendVideo(file.raw, this.md5);

					if (data.status != "uploading" && data.status != "upload_error") {
						this.$message.info("已经成功上传了！");
						this.percent = 100;
						this.videoId = data.id;
						this.status = data.status; //published uploading
						if (data.status == "published") {
							this.editVideoId = data.id;
						}
						this.getVideoDetail(this.videoId);
						return;
					} else {
						this.videoId = data.id;
					}
					let result = await this.getVideoUploadedList(
						file.raw.name,
						this.videoId,
						this.md5
					);
					this.cutBigFile(file.raw, result);
					this.uploadChunk();
				} catch (e) {
					console.log(e)
				}
			},
			//分片切割
			cutBigFile(fileObj, serverList) {
				const chunkSize = 2097152 * 8; // 将文件按固定大小（2M）进行切片，注意此处同时声明了多个常量
				let chunkList = []; // 保存所有切片的数组
				this.totalCutLen = Math.ceil(fileObj.size / chunkSize); // 计算总共多个切片
				let suffix = /\.([0-9A-z]+)$/.exec(fileObj.name)[1]; // 文件后缀名
				let curChunk = 0; // 切片时的初始位置
				for (let i = 0; i < this.totalCutLen; i++) {
					const item = {
						chunk: fileObj.slice(curChunk, curChunk + chunkSize),
						fileName: `${this.md5}_${i}.${suffix}`,
						num: Number(i) + 1,
						currentTime: 10,
					};
					curChunk += chunkSize;
					if (serverList.indexOf(item.num + "") == -1) {
						chunkList.push(item);
					}
				}
				this.chunkList = chunkList;
			},
			//到服务器端检测视频信息
			checkBackendVideo(fileObj, md5) {
				return this.$applicationJson("/business/shutcm/video/create", {
						filename: fileObj.name,
						id: "",
						md5: md5,
					})
					.then((res) => {
						if (res.data.code == 0) {
							return res.data.data;
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						return Error;
					});
			},
			//分片上传
			uploadChunk() {
				let i = 0; // 记录发送的请求个数
				const send = async () => {
					if (!this.upload || i >= this.totalCutLen || this.chunkList.length == 0)
						return;
					const requestList = []; // 请求集合
					let sendList = this.chunkList.splice(0, 5);
					sendList.forEach((item, index) => {
						const fn = () => {
							var formData = new FormData();
							formData.append("file", item.chunk);
							formData.append("id", this.videoId);
							formData.append("md5", this.md5);
							formData.append("chunks", this.totalCutLen);
							formData.append("chunk", item.num);
							return this.$multipartPost(
									"/business/shutcm/video/upload",
									formData
								)
								.then((res) => {
									if (res.data.code == 0) {
										if (this.percentCount === 0) {
											// 避免上传成功后会删除切片改变 chunkList 的长度影响到 percentCount 的值
											this.percentCount = 100 / this.totalCutLen;
										}
										this.percent += this.percentCount; // 改变进度
										if (res.data.data == 1) {
											this.percent = 100;
										}
										sendList.splice(index, 1);
									} else {
										this.$message.error("上传失败,请重新上传");
										this.videoUploadFlag = false;
										return false;
									}
									return res;
								})
								.catch((Error) => {
									//记录出错的分片，以便重传
								});
						};
						requestList.push(fn);
					});
					Promise.all(requestList.map((fn) => fn())).then((ress) => {
						i = i + ress.length;
						send();
					});
				};
				send(); // 发送请求
			},
			// 按下暂停按钮
			handleClickBtn() {
				this.upload = !this.upload;
				if (this.upload) {
					if (this.percent.toFixed() < 100) {
						this.uploadChunk();
					}
				}
			},
			//获取已经上传分片序号
			getVideoUploadedList(fileName, id, md5) {
				return this.$applicationJson("/business/shutcm/video/uploaded/list", {
						filename: fileName,
						id: id,
						md5: md5,
						sourcePath: "",
					})
					.then((res) => {
						if (res.data.code == 0) {
							return res.data.data;
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
						return Error;
					});
			},
			deployVideo() {
				this.$applicationJson("/business/shutcm/video/batch/deploy", {
						filename: this.fileObj.name, //文件名
						id: this.videoId, //课程id
						md5: this.md5, //文件文件摘要
						sourcePath: "", //上传时文件路径
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							//this.$router.push('/resourceManagement/videoManagement');
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},
			//获取视频详情
			getVideoDetail(id) {
				this.$applicationJson("/business/shutcm/video/detail", {
						id: id, //视频id
					})
					.then((res) => {
						if (res.data.code == 0) {
							if (res.data.data.title) {
								this.addUserForm.name = res.data.data.title;
							} else {
								this.addUserForm.name = res.data.data.filename.split(".")[0];
							}
							if (res.data.data.id) {
								this.videoId = res.data.data.id;
							}
							this.fileList = [];
							// FormData 对象
							this.fileList.push({
								name: res.data.data.filename,
								url: res.data.data.masterMediaUri,
							});
							if (res.data.data.status) {
								if (res.data.data.status == "published") {
									this.percent = 100;
								}
							}
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//图片转化base64
			getVideoBase64(url, currentTime) {
				let dataURL = "";
				let video = document.createElement("video");
				video.setAttribute("crossOrigin", "anonymous"); //处理跨域
				video.setAttribute("src", url);
				video.setAttribute("width", 400);
				video.setAttribute("height", 240);
				video.currentTime = currentTime;
				var that = this;
				video.addEventListener("loadeddata", () => {
					let canvas = document.createElement("canvas");
					let width = video.videoWidth; //canvas的尺寸和图片一样
					let height = video.videoHeight;
					canvas.width = width;
					canvas.height = height;
					canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
					dataURL = canvas.toDataURL("image/jpeg"); //转换为base64
					this.baseImg = dataURL;
					//console.log(dataURL)
					this.imgArr.push(dataURL);
					this.globalImageUrl = this.imgArr[0];
					this.imageUrl = this.imgArr[0];
					//console.log(this.imageUrl)
					this.fileData = new FormData(); //  用FormData存放上传文件
					let fileData = this.dataURLtoFile(this.globalImageUrl, "filename");
					this.fileData.append("file", fileData);
					//this.uploadFile();
				});
			},
			dataURLtoFile(dataurl, filename) {
				//将base64转换为文件
				var arr = dataurl.split(","),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new File([u8arr], filename, {
					type: mime,
				});
			},
			//确定
			submitForm(formName) {
				//this.$forceUpdate();
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.percent == 100) {
							if (this.md5 && !this.editVideoId) {
								this.deployVideo();
							}
							this.submitVideo();
						} else {
							this.$message.error("视频上传中,请勿操作");
						}
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			//提交视频
			submitVideo() {
				this.$applicationJson("/business/shutcm/video/edit", {
						about: "", //课时描述
						courseId: "", //课程id
						chapterId: "", //章节id
						coverImgPath: this.imageUrl, //封面路径
						free: 1, //是否免费 0收费  1免费
						id: this.videoId,
						freeTrialType: "", // 免费试看类型 0：不免费 1:10%  2:30%,
						income: "", //收入
						length: "",
						mediaUri1080: "",
						mediaUri480: "",
						mediaUri720: "",
						mediaUriOrigin: "", //原画媒体文件路径
						price: "",
						seq: "",
						sourcePath: "", //源文件路径
						status: "", //published：已通过 publishing：转码中 unpublished：未通过 ,
						title: this.addUserForm.name,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getVideoList(this.currentPage);
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},
			//获取视频列表
			getVideoList(page) {
				this.$applicationJson("/business/shutcm/video/paging", {
						orderBy: null,
						orderType: 1, //0正序  1倒序
						page: page,
						pageSize: 10,
						params: {
							title: this.searchData.name,
						},
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},
			//格式化时间
			formatDurings(mss) {
				let hours = Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				if (hours < 10) {
					hours = "0" + hours;
				}
				let minutes = Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				let seconds = Math.floor((mss % (1000 * 60)) / 1000);
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				return hours + ":" + minutes + ":" + seconds;
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getVideoList(0);
				this.editVideoId = this.$route.query.id;
				if (this.editVideoId) {
					this.videoUploadFlag = true;
					this.getVideoDetail(this.editVideoId);
				}
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 60px;
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}

			.demo-form-inline {
				margin-top: 10px;

				:deep(.el-input__inner){
					width: 220px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}
		}
	}

	.dialog {
		:deep(.el-dialog__body){
			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner) {
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;

		img {
			float: left;
			width: 40px;
		}

		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}

	.select {
		margin-left: 40px;
		width: calc(100% - 40px);

		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;

			li {
				float: left;
				width: 120px;
				text-align: center;

				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}

					width: 40px;
					height: 40px;
				}

				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}

		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;

			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}

			.li {
				float: left;
				width: calc(100% - 110px);

				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;

					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}

					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
